import { useState } from 'react';

import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ActionTypeSearchDialog } from './ActionTypeSearchDialog';
import { CreateEditActionDialog } from './CreateEditActionDialog';

export const CreateActionDialogs = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const { article } = useArticleContext();
  const [createdActionId, setCreatedActionId] = useState<string>();

  const createdAction = article.snapshot.articleActions.find((d) => d.id === createdActionId);

  return (
    <>
      <ActionTypeSearchDialog
        isOpen={isOpen && !createdAction}
        onClose={() => setIsOpen(false)}
        onActionCreated={setCreatedActionId}
      />
      <CreateEditActionDialog
        isOpen={isOpen && !!createdAction}
        setIsOpen={(newIsOpen) => {
          setIsOpen(newIsOpen);

          if (!newIsOpen) {
            setCreatedActionId(undefined);
          }
        }}
        action={createdAction}
        mode="create"
      />
    </>
  );
};
